var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeExtension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 9.78306C15.9357 9.78306 16 9.71877 16 9.6402V8.6402C16 8.56163 15.9357 8.49734 15.8571 8.49734H4.17857C4.05067 8.18065 3.83102 7.90943 3.54782 7.71851C3.26463 7.5276 2.93082 7.4257 2.58929 7.42591C1.64286 7.42591 0.875 8.19377 0.875 9.1402C0.875 10.0866 1.64286 10.8545 2.58929 10.8545C3.30893 10.8545 3.925 10.4116 4.17857 9.78306H6.8625V12.4973C6.8625 13.4831 7.6625 14.2831 8.64821 14.2831H15.8571C15.9357 14.2831 16 14.2188 16 14.1402V13.1402C16 13.0616 15.9357 12.9973 15.8571 12.9973H8.64821C8.37143 12.9973 8.14821 12.7741 8.14821 12.4973V9.78306H15.8571ZM7 4.99734H11.7143V6.75091C11.7143 6.89556 11.8839 6.97948 11.9964 6.88841L15.0768 4.45627C15.1661 4.38663 15.1661 4.2527 15.0768 4.18305L11.9964 1.74912C11.8821 1.65805 11.7143 1.7402 11.7143 1.88662V3.6402H7C6.92143 3.6402 6.85714 3.70448 6.85714 3.78305V4.85448C6.85714 4.93305 6.92143 4.99734 7 4.99734Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeExtension);
export default __webpack_public_path__ + "static/media/node-extension.74fb5dc41524b7fd1c66186a3eb8845a.svg";
export { ForwardRef as ReactComponent };